<template>
  <vue-ueditor-wrap
    destroy
    v-model="content"
    mode="listener"
    :observerDebounceTime="100"
    ref="ueditor"
    :config="ueditorConfig"
    class="ueditor-css"
  />
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap';
const ueditorConfig = {
  // 如果需要上传功能,找后端小伙伴要服务器接口地址
  // serverUrl: '/api/base/config',
  // serverUrl: '/base/config',
  // 你的UEditor资源存放的路径,相对于打包后的index.html
  UEDITOR_HOME_URL: './UEditor/',
  // 编辑器不自动被内容撑高
  autoHeightEnabled: false,
  // wordCount: false,
  // 初始容器高度
  initialFrameHeight: 200,
  // 初始容器宽度
  initialFrameWidth: '100%',
  // 关闭自动保存
  enableAutoSave: false,
  elementPathEnabled: false,
  wordCount: true, // 是否开启字数统计
  maximumWords: 1000, // 允许的最大字符数
  toolbars: [
    [
      'undo', // 撤销
      'bold', // 加粗
      'indent', // 首行缩进
      'italic', // 斜体
      'underline', // 下划线
      'strikethrough', // 删除线
      'subscript', // 下标
      'superscript', // 上标
      'formatmatch', // 格式刷
      'blockquote', // 引用
      // 'pasteplain', //纯文本粘贴模式
      // 'selectall', //全选
      'horizontal', // 分隔线
      'removeformat', // 清除格式
      'inserttitle', // 插入标题
      'cleardoc', // 清空文档
      'insertparagraphbeforetable', // '表格前插入行'
      // 'insertcode', //代码语言
      'fontfamily', // 字体
      'fontsize', // 字号
      'paragraph', // 段落格式
      // 'edittable', //表格属性
      // 'edittd', //单元格属性
      // 'link', //超链接
      // 'spechars', //特殊字符
      // 'searchreplace', //查询替换
      // 'help', //帮助
      'justifyleft', // 居左对齐
      'justifyright', // 居右对齐
      'justifycenter', // 居中对齐
      'justifyjustify', // 两端对齐
      'forecolor', // 字体颜色
      'backcolor', // 背景色
      'insertorderedlist', // 有序列表
      'insertunorderedlist', // 无序列表
      'fullscreen', // 全屏
      'directionalityltr', // 从左向右输入
      'directionalityrtl', // 从右向左输入
      'rowspacingtop', // 段前距
      'rowspacingbottom', // 段后距
      // 'imagenone', //默认
      // 'imageleft', //左浮动
      // 'imageright', //右浮动
      // 'imagecenter', //居中
      // 'wordimage', //图片转存
      'lineheight' // 行间距
      // 'edittip ', //编辑提示
      // 'customstyle', //自定义标题
      // 'autotypeset', //自动排版
      // 'touppercase', //字母大写
      // 'tolowercase', //字母小写
    ]
  ]
}
export default {
  name: 'UEditor',
  props: {
    value: {
      type: String
    },
    max: {
      type: Number,
      default: 1000
    }
  },
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      content: '',
      ueditorConfig: {
        ...ueditorConfig,
        maximumWords: this.max
      }
    }
  },
  watch: {
    value () {
      this.content = this.value
    },
    content () {
      this.$emit('change', this.content)
      if (this.$refs.ueditor.editor !== null) {
        this.$emit('maxlength', this.$refs.ueditor.editor.getContentTxt().length)
      }
    }
  },
  mounted () {
    this.content = this.value
  }
}
</script>
<style>
.edui-editor div {
  line-height: 22px;
}
</style>
